<template>
  <div>
    <div
      class="payment"
      :class="{ 'payment-bordered': isSellTransaction }"
    >
      <div v-if="isIframe" class="iframe">
        <a :href="cartUrl" target="_blank" class="button button--checkout">
          Add to cart
        </a>
      </div>
      <div v-else>
        <button
          class="button button--primary"
          @click="addToCart"
          id="addToCart"
          v-if="!store.offlineBranch"
          :disabled="loading"
        >
          <span v-if="isSellTransaction">Add to cart</span>
          <span v-else-if="isBuyTransaction">Sell back now</span>
          <span v-else>Select a branch</span>
        </button>

          <span v-if="store.offlineBranch">{{content.offlineBranchMessage || "Sorry, we cannot offer currency at this store at the moment"}}</span>
      </div>

      <div class="spinner" v-if="loading">
        <Spinner name="circle" color="var(--color-links)" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { SITE_ID } from '@vue/common/constants/config'
import { TransactionTypes } from '@vue/common/constants/transactionTypes'
import { ProductTypes } from '@vue/common/constants/productTypes'
import { showError } from '@vue/services/toast.service';

import Spinner from 'vue-spinkit'

export default {
  name: 'CalculatorResult',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: false,
      domain: this.$root.origin,
      isIframe: this.$root.isIframe,
    }
  },
  computed: {
    ...mapGetters({
      isSellTransaction: 'calculator/isSellTransaction',
      isBuyTransaction: 'calculator/isBuyTransaction',
    }),
    ...mapState({
      selectedProduct: (state) => state.calculator.selectedProduct,
      store: (state) => state.store.store,
      defaultStore:  (state) => state.store.defaultStore,
      shoppingCart: (state) => state.cart.shoppingCart,
      selectedCurrency: (state) => state.calculator.selectedCurrency,
      quantity: (state) => state.calculator.quantity,
      content: (state) => state.calculator.content
    }),
    iframeQuery() {
      const query = {
        currency: this.selectedCurrency.code,
        amount: this.quantity,
        product_id: this.selectedProduct.id
      }

      if (this.store.id !== 1) {
        query.store_id = this.store.id
      }

      const iframeContext = new URLSearchParams(window.location.search);
      if (iframeContext.has('affiliateid')) {
        query.affiliateid = iframeContext.get('affiliateid');
      }

      return new URLSearchParams(query).toString()
    },
    cartUrl() {
      return this.selectedProduct.id === 3
        ? `${this.domain}/selling/view-cart?${this.iframeQuery}`
        : `${this.domain}/checkout/view-cart?${this.iframeQuery}`
    },
  },
  methods: {
    ...mapActions({
      createSession: 'session/create',
      addLine: 'cart/addLine',
      createCart: 'cart/createCart'
    }),

    async addToCart() {
      this.loading = true;

      // Ignore "selected branch" (store.Id) if product selection is delivery as that can only be purchased
      // from the "home delivery branch" (isMeta = true).
      const storeId = this.selectedProduct.id === ProductTypes.HOME_DELIVERY
          ? this.defaultStore.id
          : this.store.id;

      if (!this.shoppingCart) {
        try {
          await this.createSession();
          const { data } = await this.createCart({
            productId: this.selectedProduct.id,
            storeId: storeId,
            initialOrderLine: {
              currencyCode: this.selectedCurrency.code,
              qty: this.quantity,
            }
          });
    
          const uri = this.selectedProduct.transactionType === TransactionTypes.SELL
              ? '/checkout/view-cart'
              : '/selling/view-cart';
          window.location.href = uri;
        }
        finally {
          this.loading = false;
        }
      } 
    },
  },
}
</script>
